import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Heading1, StackView } from 'localmed-core';

import style from './AppointmentFormPage.scss';

import LegacyPanel from '../../../legacyCore/LegacyPanel';
import StaticMap from '../../../legacyCore/StaticMap';
import AppointmentForm, {
  AppointmentFormInfo,
  OpeningNotAvailable,
} from '../../../shared/components/AppointmentForm';
import { createSchedulingSessionStateLandingPage } from '../../../shared/components/SchedulingSessionState';

import isOpeningAvailable from '../../../shared/utils/isOpeningAvailable';
import MainLayout from '../../components/MainLayout';
import LoadingPage from '../LoadingPage';
import NotFoundPage from '../NotFoundPage';
import AppointmentVerify from './AppointmentVerify';

class AppointmentFormPage extends Component {
  state = {
    showVerification: false,
    email: undefined,
  };

  showVerification = (email) => {
    this.setState({
      showVerification: true,
      email,
    });
  };

  renderFormBody = () => {
    const { location, history, openingData, providerData } = this.props;
    const { currentUser, opening } = openingData;
    const { provider } = providerData;

    return (
      <StackView spacing={['sm', 'sm', 'md']}>
        <Heading1
          fontWeight="bold"
          lineHeight="solid"
          marginTop="md"
          className={style['appointment-form-page__title']}
        >
          Schedule an Appointment
          <br />
          <small>with {provider.display}</small>
        </Heading1>
        <LegacyPanel p={0} mb={0}>
          <AppointmentForm
            location={location}
            history={history}
            currentUser={currentUser}
            provider={provider}
            opening={opening}
            showVerification={this.showVerification}
            useMainLayout
          />
        </LegacyPanel>
      </StackView>
    );
  };

  renderVerificationBody() {
    const { email } = this.state;
    if (email == null) {
      throw new Error('Cannot render verification body without `email`');
    }
    const { openingData, providerData } = this.props;
    const { currentUser, opening } = openingData;
    const { provider } = providerData;

    return (
      <StackView spacing={['sm', 'sm', 'md']}>
        <Heading1
          fontWeight="bold"
          lineHeight="solid"
          className={style['appointment-form-page__title']}
          marginTop="md"
        >
          <small>Last Step!</small>
          <br />
          Verify your Email Address
        </Heading1>
        <LegacyPanel size="lg" mb={0}>
          <AppointmentVerify
            currentUser={currentUser}
            opening={opening}
            provider={provider}
            email={email}
          />
        </LegacyPanel>
      </StackView>
    );
  }

  render() {
    const {
      location,
      match: { params },
      providerData,
      openingData,
    } = this.props;
    const { showVerification } = this.state;

    if (providerData.loading) {
      return <LoadingPage currentUser={null} />;
    }
    if (providerData.error) {
      return <MainLayout error={providerData.error} />;
    }
    if (!providerData.provider || !providerData.provider.onlineSchedulingEnabled) {
      return <NotFoundPage currentUser={null} />;
    }
    if (openingData == null || openingData.loading) {
      return <LoadingPage currentUser={null} />;
    }
    if (openingData.error) {
      return <MainLayout error={openingData.error} />;
    }

    const { currentUser, opening } = openingData;
    const { provider } = providerData;
    const { office } = provider;

    if (!isOpeningAvailable(opening)) {
      return (
        <OpeningNotAvailable location={location} params={params} provider={provider}>
          <LoadingPage />
        </OpeningNotAvailable>
      );
    }

    return (
      <MainLayout currentUser={currentUser}>
        <Helmet>
          <title>Schedule an Appointment</title>
          <meta name="robots" content="noindex" />
        </Helmet>
        <div className={style['appointment-form-page__row']}>
          <div className={style['appointment-form-page__main']}>
            {showVerification ? this.renderVerificationBody() : this.renderFormBody()}
          </div>
          <div className={style['appointment-form-page__aside']}>
            <StaticMap
              className={style['appointment-form-page__map']}
              width="100%"
              height="192"
              zoom={12}
              markers={[{ latitude: office.latitude, longitude: office.longitude }]}
            />
            <LegacyPanel px={0} mb={0}>
              <AppointmentFormInfo provider={provider} opening={opening} large />
            </LegacyPanel>
          </div>
        </div>
      </MainLayout>
    );
  }
}

export default createSchedulingSessionStateLandingPage(AppointmentFormPage);
